import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { InvestigationFormEntity } from '../../../domain/entities/investigation-form.entity';
import { InvestigationFormRepository } from '../../../infrastructure/repositories/investigation-form.repository';
import { InvestigationFormState } from '../../states/investigation-form.state';
import { GetInvestigationFormsByInvestigationTypeQuery } from './get-investigation-forms-by-investigation-type.query';

@Injectable({ providedIn: 'root' })
export class GetInvestigationFormsByInvestigationTypeUseCase {
  private readonly _repository = inject(InvestigationFormRepository);
  private readonly _state = inject(InvestigationFormState);

  public execute(query: GetInvestigationFormsByInvestigationTypeQuery): Observable<InvestigationFormEntity[]> {
    this._state.setLoadingInvestigationForms(true);
    this._state.clearErrorInvestigationForms();

    return this._repository.getInvestigationFormsByInvestigationTypeId(query.investigationTypeId).pipe(
      tap((forms) => {
        this._state.setInvestigationForms(forms);
      }),
      catchError((error) => {
        const errorMessage = error?.error?.message || error?.message ||
          `Failed to load investigation forms for investigation type ${query.investigationTypeId}`;
        this._state.setErrorInvestigationForms(errorMessage);
        throw error;
      }),
      finalize(() => this._state.setLoadingInvestigationForms(false))
    );
  }
}
